import { useUserStore } from '~/store/useUserStore'

export default defineNuxtRouteMiddleware(async () => {
  const userStore = useUserStore()
  const { fetchData: fetchUser, set } = userStore
  const { hasLoginCookie } = storeToRefs(userStore)

  if (!hasLoginCookie.value) {
    return
  }

  const data = await fetchUser()
  if (data) {
    set(data)
  }
})
